import { useDispatch } from 'react-redux';

import { toggleNewProjectModal } from "../../../../actions";
import EmptyState from '../../atoms/empty-state/EmptyState';
import { FormattedMessage, useIntl } from 'react-intl';
import useNavigateWithPersistedParams from '../../../../js/useNavigateWithPersistedParams';
import { getProjectColourPalette } from '../../../../js/helper';

const ProjectsTooltip = (props) => {
  const intl = useIntl();
  const navigate = useNavigateWithPersistedParams();
  const dispatch = useDispatch();

  const projects = props.projects;

  return (
    <div style={{ background: '#1c1d21', display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <header className="flex align-center justify-between px-4 py-3 flex-shrink-0" style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
        <h2 className="font-semibold text-sm" style={{ color: 'rgba(255,255,255,0.85)' }}>
          <FormattedMessage id="PROJECTS" defaultMessage="Projects" />
        </h2>
        <button
          className="flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-lg transition-colors"
          style={{ background: 'rgba(99,102,241,0.2)', border: '1px solid rgba(99,102,241,0.4)', color: 'rgba(165,180,252,0.95)' }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(99,102,241,0.32)'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(99,102,241,0.2)'}
          onClick={() => dispatch(toggleNewProjectModal({ value: true }))}
        >
          <span style={{ fontSize: 14, lineHeight: 1 }}>+</span>
          <FormattedMessage id="ADD_PROJECT" defaultMessage="Add Project" />
        </button>
      </header>
      <div className="py-1.5 overflow-y-auto flex-1">
        {projects?.length > 0 ? projects.map((project, index) => {
          const palette = getProjectColourPalette(project?.metadata?.colour);
          const initials = project?.title?.slice(0, 2)?.toUpperCase() || '';
          const isActive = window?.location?.pathname.includes(project?._id);
          return (
            <div
              key={project?._id || index}
              className="flex align-center gap-3 px-3 py-2.5 cursor-pointer mx-1.5 rounded-lg transition-colors"
              style={{ background: isActive ? 'rgba(255,255,255,0.07)' : '' }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.06)'}
              onMouseLeave={e => e.currentTarget.style.background = isActive ? 'rgba(255,255,255,0.07)' : ''}
              onClick={() => navigate(`/${project?._id}/${localStorage.getItem('projectLastView') || 'board'}`)}
            >
              <div
                className="flex-shrink-0 flex items-center justify-center rounded-lg text-xs font-bold"
                style={{ width: 32, height: 32, background: palette.bg, border: `1px solid ${palette.border}`, color: palette.text, letterSpacing: '0.04em' }}
              >
                {initials}
              </div>
              <span className="truncate text-sm font-medium" style={{ color: 'rgba(255,255,255,0.85)' }}>{project?.title}</span>
            </div>
          );
        }) : (
          <div className="my-4 px-3">
            <EmptyState
              header={intl.formatMessage({ id: 'NO_PROJECTS', defaultMessage: 'You Have No Projects!' })}
              description={intl.formatMessage({ id: 'CREATE_PROJECT_TO_GET_STARTED', defaultMessage: 'Create a new project to get started.' })}
              iconSize='h-16 w-16'
              src='/images/icons/no-task.svg'
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectsTooltip;
